import { parseTextBlock } from '@blaze-react/drafteditor';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { Link } from '@blaze-cms/nextjs-components';
import YachtAutomaticDescription from './YachtAutomaticDescription';

const query = gql`
  query getEntityData($id: String!) {
    entityData: getPublishedYachtPage(id: $id) {
      introduction
      name
      publishedBuilderProfiles {
        id
        professionalId
        name
        slug
      }
      publishedInternalDesignerProfiles {
        id
        professionalId
        name
        slug
      }
      publishedExteriorDesignerProfiles {
        id
        professionalId
        name
        slug
      }
      publishedNavalArchitectProfiles {
        id
        professionalId
        name
        slug
      }
      id
      __typename
    }
  }
`;

const YachtDescription = ({ parent: { itemId }, useCustomDescription, customDescription }) => {
  const { data, error, loading } = useQuery(query, {
    variables: { id: itemId }
  });

  if (loading) return 'loading...';
  if (error) return error.message;
  if (!data || !data.entityData) return null;

  const professionalsMap = {};
  data.entityData.publishedBuilderProfiles.forEach(
    profileData => (professionalsMap[profileData.professionalId] = profileData)
  );
  data.entityData.publishedInternalDesignerProfiles.forEach(
    profileData => (professionalsMap[profileData.professionalId] = profileData)
  );
  data.entityData.publishedExteriorDesignerProfiles.forEach(
    profileData => (professionalsMap[profileData.professionalId] = profileData)
  );
  data.entityData.publishedNavalArchitectProfiles.forEach(
    profileData => (professionalsMap[profileData.professionalId] = profileData)
  );

  if (useCustomDescription) {
    const parsedTextBlock = parseTextBlock({ editor: customDescription, LinkWrapper: Link });

    return (
      <>
        {parsedTextBlock}

        <h5>About {data.entityData.name}, brought to you by BOATPro</h5>

        <YachtAutomaticDescription
          text={data.entityData.introduction}
          professionalsMap={professionalsMap}
        />
      </>
    );
  }

  return (
    <YachtAutomaticDescription
      text={data.entityData.introduction}
      professionalsMap={professionalsMap}
    />
  );
};

export default YachtDescription;
